<template>
  <div class="downloads">
    <div v-if="title" class="downloads-title">
      <h3>{{ title }}</h3>
    </div>
    <div class="container">
      <div v-for="(section, index) in downloads" :key="index"  class="section">
        <div class="section-title">
          <h4 class="title">{{ section.title }}</h4>
        </div>
        <div class="section-body">
          <ul v-if="section.title == 'Downloadable Icon Library'" class="downloads-list">
            <li class="download" v-for="(download, index) in section.files" :key="index" @click="downloadIcons()">
              <div class="download-icon">
                <i class="icon icon--download"></i>
              </div>
              <div class="download-details">
                <a class="name">{{download.name}}</a>
              </div>
            </li>
          </ul>
          <ul v-else-if="section.title == 'Downloadable Icon PPTX'" class="downloads-list">
            <li class="download" v-for="(download, index) in section.files" :key="index" @click="downloadPowerPoint()">
              <div class="download-icon">
                <i class="icon icon--download"></i>
              </div>
              <div class="download-details">
                <a class="name">{{download.name}}</a>
              </div>
            </li>
          </ul>
          <ul v-else class="downloads-list">
            <li class="download" v-for="(download, index) in section.files" :key="index">
              <div class="download-icon">
                <a :href="download.url">
                  <i class="icon icon--download"></i>
                </a>
              </div>
              <div class="download-details">
                <a :href="download.url" class="name">{{ download.name }}</a>
                <p class="contents">{{ download.contents }}</p>
              </div>
            </li>
          </ul>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Api from '../utils/api';

export default {
  props: {
    title: {
      type: String,
      required: false,
    },
    downloads: {
      type: Array,
      required: true,
    }
  },
  methods: {
    downloadIcons() {
      let loader = this.$loading.show()
      Api.get(`/download/icons`, {
        method: 'GET',
        responseType: 'blob', // important
      }).then((response) => {
        const url = window.URL.createObjectURL(new Blob([response.data]));
        const link = document.createElement('a');
        link.href = url;
        const d = new Date()
        link.setAttribute('download', `icons-${d.getFullYear()}-${d.getMonth()}-${d.getDay()}.zip`);
        document.body.appendChild(link);
        link.click();
        link.parentNode.removeChild(link);
        loader.hide()
      })
      .catch(error => {
        console.log(error)
        alert("Sorry, something went wrong")
        loader.hide()
      })
    },
    downloadPowerPoint() {
      let loader = this.$loading.show()
      Api.get(`/download/powerpoint`, {
        method: 'GET',
        responseType: 'blob', // important
      }).then((response) => {
        const url = window.URL.createObjectURL(new Blob([response.data], { type: 'application/vnd.openxmlformats-officedocument.presentationml' }));
        const link = document.createElement('a');
        link.href = url;

        link.setAttribute('download', 'icons.pptx');
        document.body.appendChild(link);
        link.click();
        link.parentNode.removeChild(link);
        loader.hide()
      })
      .catch(error => {
        console.log(error)
        alert("Sorry, something went wrong")
        loader.hide()
      })
    },
  }
}
</script>

<style lang="scss" scoped>
  @import '../styles/mixins';

  .downloads-title {
    margin-bottom: 22px;

    h3 {
      font-family: var(--f-bold);
      font-size: 18px;
      color: #16162D;
      letter-spacing: 0;
      line-height: 28px;
    }
  }

  .container {
    border: 1px solid #3256FF;
    border-radius: 8px;
    padding: 35px;
    display: flex;
    max-width: 620px;

    @include bp(768px) {
      padding: 35px 18px;
    }

    @include bp(520px) {
      flex-direction: column;
    }
  }

  .section {
    flex: 1;

    @include bp(520px) {
      @include not-last {
        margin-bottom: 68px;
      }
    }
  }

  .section-title {
    padding: 0 0 24px 12px;
    border-bottom: 1px solid #3256FF;

    .title {
      font-family: var(--f-regular);
      font-weight: normal;
      font-size: 18px;
      color: #16162D;
    }
  }

  .section-body {
    padding: 35px 24px 0 12px;
  }

  .download {
    display: flex;
    &:not(:last-of-type) {
      margin-bottom: 18px;
    }

    .download-icon {
      flex: 0 0 35px;
    }

    .name {
      font-family: var(--f-bold);
      font-size: 13px;
      color: #16162D;
      line-height: normal;
    }
  }
</style>
